import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import moment from 'moment';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { WorkerCalendarEvent } from '../../_types/worker-calendar-event';
import { WorkersCalendarsEventsService } from '../../_services/workers-calendars-events.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { CalendarsEventsTypesService } from 'src/app/modules/calendars/_services/calendars-events-types.service';
import { firstValueFrom } from 'rxjs';
import { CalendarEventType } from 'src/app/modules/calendars/_types/calendar-event-type';
import { AndFilter, Filter, FilterOperation, OrFilter } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { CasesService } from 'src/app/modules/cases/_services/cases.service';
import { CasesServicesService } from 'src/app/modules/cases/_services/cases-services.service';
import { GuardsShiftsDatesService } from 'src/app/modules/guards-shifts/_services/guards-shifts-dates.service';
import { WorkerGuardShiftsService } from '../../_services/workers-guards-shifts.service';
import { WorkersCalendarsEventsDetailsModalComponent } from '../calendars-events-details-modal/workers-calendars-events-details-modal.component';
import { consumerPollProducersForChange } from '@angular/core/primitives/signals';

@Component({
    selector: 'app-workers-calendars-events-modal.component',
    templateUrl: './workers-calendars-events-modal.component.html',
    standalone: false
})
export class WorkersCalendarsEventsModalComponent {

  public workerCalendarEventsFormGroup!: RxFormGroup;

  public selectedWorkerCalendarEvent: WorkerCalendarEvent = new WorkerCalendarEvent;
  public calendarEventTypes: any = [];
  public calendarEventTypeSelected: any = {};
  public caseServices: any = [];
  
  public serviceFoundModal: boolean = false;
  public guardShiftFoundModal: boolean = false;
  public deleteWorkerCalendarEvents: boolean = false;
  public workerCalendarEvents: any = [];
  public visibleDeleteMultipleModal: boolean = false;
  public deleteEventType: any = null;
  public selectedWorkerCalendarEvents: any[] = [];

  constructor(
    private messageService: MessageService,
    private dialogService: DialogService,
    public config: DynamicDialogConfig,
    private confirmationService: ConfirmationService,
    private workersCalendarsEventsServices: WorkersCalendarsEventsService,
    private formBuilder: RxFormBuilder,
    private workersCalendarsEventsService: WorkersCalendarsEventsService,
    private casesServicesService: CasesServicesService
  ) {
    this.workerCalendarEventsFormGroup = this.formBuilder.formGroup<WorkerCalendarEvent>(this.selectedWorkerCalendarEvent) as RxFormGroup;
  }

  async ngOnInit(): Promise<void> {
    await this.loadWorkerCalendarEvents();
    await this.loadCasesServices();
  }

  async loadWorkerCalendarEvents(){
    const selectedDates = this.config.data.selectedDates ?? [];
    let filters: any = {
      workerId: new Filter(FilterOperation.equals, 'workerId', '', this.config.data.workerId)
    }

    if(selectedDates.length > 0){
      const dateFilters: AndFilter[] = [];

      selectedDates.forEach((date: any) => {
        console.log(date);

        const parsedDate = moment(date);
        if (!parsedDate.isValid()) return;

        dateFilters.push(new AndFilter([
          new Filter(FilterOperation.greaterOrEqual, 'date', '', parsedDate.clone().startOf("day").toISOString()),
          new Filter(FilterOperation.lessOrEqual, 'date', '', parsedDate.clone().endOf("day").toISOString())
        ]));
      });

      if (dateFilters.length > 0) {
        filters.selectedDates = new OrFilter(dateFilters);
      }
    } else {
      const fromDate = this.config.data.start != null ? moment(this.config.data.start) : moment(this.config.data.date);
      const toDate = this.config.data.end != null ? moment(this.config.data.end) : moment(this.config.data.date);

      filters.fromDate = new Filter(FilterOperation.greaterOrEqual, 'date', '', fromDate.startOf("day").toISOString());
      filters.toDate = new Filter(FilterOperation.lessOrEqual, 'date', '', toDate.endOf("day").toISOString());
    }

    console.log(filters);

    let params: IParamsCollection = {       
      filter: FilterBuilder.fromObject(filters).build(),
      include: ['calendarEventType'],
      sort: ['date','start']
    };

    let response = await firstValueFrom(this.workersCalendarsEventsService.all(params));
    this.workerCalendarEvents = response.data;
  }


  async loadCasesServices(){
    let filters: any = {
     // date1: new Filter(FilterOperation.greaterOrEqual, 'date', '',this.config.data.start != null? moment(this.config.data.start).startOf("day").toISOString(): moment(this.config.data.date!).startOf("day").toISOString()),
     // date2: new Filter(FilterOperation.lessThan, 'date', '', this.config.data.end != null ?moment(this.config.data.end).endOf("day").toISOString() : moment(this.config.data.date!).endOf("day").toISOString()),
      workerId: new Filter(FilterOperation.equals, 'workerId', '', this.config.data.workerId),
      isCancelled: new Filter(FilterOperation.equals, 'isCancelled', '', false)
    };
    const selectedDates = this.config.data.selectedDates ?? [];  
    if(selectedDates.length > 0){
      const dateFilters: AndFilter[] = [];

      selectedDates.forEach((date: any) => {
        console.log(date);

        const parsedDate = moment(date);
        if (!parsedDate.isValid()) return;

        dateFilters.push(new AndFilter([
          new Filter(FilterOperation.greaterOrEqual, 'date', '', parsedDate.clone().startOf("day").toISOString()),
          new Filter(FilterOperation.lessOrEqual, 'date', '', parsedDate.clone().endOf("day").toISOString())
        ]));
      });

      if (dateFilters.length > 0) {
        filters.selectedDates = new OrFilter(dateFilters);
      }
    } else {
      const fromDate = this.config.data.start != null ? moment(this.config.data.start) : moment(this.config.data.date);
      const toDate = this.config.data.end != null ? moment(this.config.data.end) : moment(this.config.data.date);

      filters.date1 = new Filter(FilterOperation.greaterOrEqual, 'date', '', fromDate.startOf("day").toISOString());
      filters.date2 = new Filter(FilterOperation.lessOrEqual, 'date', '', toDate.endOf("day").toISOString());
    }



    let params: IParamsCollection = {
      include: ['case'],
      sort: ['date'],
      page: { size: 50 },
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.casesServicesService.all(params));
    
    response.data.forEach((caseService:any) => {
      let item = {
        calendarEventType: { name: "Cita"},
        date: caseService.date,
        start: (caseService.dateStart != null ? moment(caseService.dateStart).format("HH:mm") : moment(caseService.date).format("HH:mm")),
        end: (caseService.dateEnd != null ? moment(caseService.dateEnd).format("HH:mm") : "--"),
        description: caseService.case?.caseNumber,
        caseid: caseService.caseId,
        type: "caseService"
      }
      this.workerCalendarEvents.push(item);
    });

    this.workerCalendarEvents = this.workerCalendarEvents.sort((a:any,b:any) => {
      if(moment(a.date).format('yyyy-MM-DD') + " " + a.start < moment(b.date).format('yyyy-MM-DD') + " " + b.start) return -1;
      if(moment(a.date).format('yyyy-MM-DD') + " " + a.start > moment(b.date).format('yyyy-MM-DD') + " " + b.start) return 1;
      return 0;
    });
  }

  async newWorkerCalendarEvent(){
    let newEvent: WorkerCalendarEvent = new WorkerCalendarEvent();
    newEvent.workerId = this.config.data.workerId;
    newEvent.date = this.config.data.date;
    newEvent.start = this.config.data.start;
    newEvent.end = this.config.data.end;
    newEvent.list_dates = this.config.data.selectedDates ?? [];
    const ref = this.dialogService.open(WorkersCalendarsEventsDetailsModalComponent, {
      closable: true,
      modal: true,
      data: {
        event: newEvent
      },
      //header: this.config.data.type == "day" ? "Día: " + newEvent.date?.format('DD/MM/YYYY') : "Rango: " + newEvent.start?.format('DD/MM/YYYY') + " - " + newEvent.end?.format('DD/MM/YYYY'),
      header: 'Nuevo evento',
      width: "400px",
    });
    ref.onClose.subscribe(async (result: any) => {
      
          await this.loadWorkerCalendarEvents();
          await this.loadCasesServices();
    });
  }

  async editWorkerCalendarEvent(event: any){
    if(event.calendarEventType?.name != "Cita"){
      const ref = this.dialogService.open(WorkersCalendarsEventsDetailsModalComponent, {
        closable: true,
        modal: true,
        data: {
          event: event
        },
        //header: this.config.data.type == "day" ? "Día: " + this.config.data.date?.format('DD/MM/YYYY') : "Rango: " + this.config.data.start?.format('DD/MM/YYYY') + " - " + this.config.data.end?.format('DD/MM/YYYY'),
        header: 'Editar evento',
        width: "400px",
      });
      ref.onClose.subscribe(async (result: any) => {
        
          await this.loadWorkerCalendarEvents();
          await this.loadCasesServices();
      });
    }else{
      //abrimos el servicio.
      window.open("/cases/" + event.caseid, "_blank");
    }
  }

  async deleteWorkerCalendarEvent(event: any){
    this.confirmationService.confirm({
      message: "¿Quieres eliminar el evento del " + moment(event.date).format("DD/MM/YYYY") + "?",
      header: "Eliminar evento",
      icon: 'pi pi-exclamation-triangle',
      accept: async () => {
        this.workersCalendarsEventsServices.delete(event.id).subscribe({
          next: async (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Evento eliminado correctamente" });
            
            await this.loadWorkerCalendarEvents();
            await this.loadCasesServices();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  dismiss() {
    //this.activeModal.dismiss();
  }

 async deleteMultipleWorkerCalendarEvents(){
  console.log(this.selectedWorkerCalendarEvents.filter(m => m.calendarEventType?.name != 'Cita'));
  this.confirmationService.confirm({
      message: "¿Quieres eliminar los eventos seleccionados?",
      header: "Eliminar eventos",
      icon: 'pi pi-exclamation-triangle',
      accept: async () => {
        try {
          await Promise.all(this.selectedWorkerCalendarEvents.filter(m => m.calendarEventType?.name != 'Cita').map((event: any) =>
            firstValueFrom(this.workersCalendarsEventsServices.delete(event.id))
          ));

          this.messageService.add({ closable: true, severity: 'success', detail: "Eventos eliminados correctamente" });
          this.selectedWorkerCalendarEvents = [];
          await this.loadWorkerCalendarEvents();
          await this.loadCasesServices();
        } catch (error: any) {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
 }

}
